import OffersPreviewV2 from './OffersPreviewV2';

export default OffersPreviewV2;
